import type { Reason } from '../graphql/query/getOrder';

/**
 * Normalizes a scope value to handle case variations and whitespace
 * @param scope - The scope value to normalize
 * @returns The normalized scope value in lowercase, trimmed
 */
const normalizeScope = (scope: unknown): string => {
  return String(scope).toLowerCase().trim();
};

/**
 * Checks if a resolution has shipment scope
 * @param resolution - The resolution to check (can be null)
 * @returns True if the resolution has shipment scope
 */
const hasShipmentScope = (resolution: { scope?: unknown } | null): boolean => {
  if (!resolution) {
    return false;
  }
  return normalizeScope(resolution.scope) === 'shipment';
};

/**
 * Checks if all resolutions for a given reason have shipment scope
 */
export const hasAllResolutionsShipmentScope = (reason: Reason): boolean => {
  if (!reason.resolutions || reason.resolutions.length === 0) {
    return false;
  }

  return reason.resolutions.every(hasShipmentScope);
};

/**
 * Checks if a reason has any resolutions with shipment scope
 */
export const hasAnyResolutionShipmentScope = (reason: Reason): boolean => {
  if (!reason.resolutions || reason.resolutions.length === 0) {
    return false;
  }

  return reason.resolutions.some(hasShipmentScope);
};
